const state = {
  lastLayout: null,
  globalFilter: null,
};

const getters = {
  getLastLayout: (state) => state.lastLayout,
  getGlobalFilter: (state) => state.globalFilter,
};

const actions = {
  setLastLayout({ commit }, layout) {
    commit("updateLastLayout", layout);
  },
  setGlobalFilter({ commit }, filter) {
    commit("updateGlobalFilter", filter);
  },
};

const mutations = {
  updateLastLayout(state, layout) {
    state.lastLayout = layout;
  },
  updateGlobalFilter(state, filter) {
    state.globalFilter = filter;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
